import {
    BadgeCheck,
    Quote,
    Star,
} from "lucide-react";
import "./SellerTestimonials.css";

type SellerTestimonial = {
    id: number;
    name: string;
    business: string;
    title: string;
    review: string;
    image: string;
    rating: number;
};

const testimonials: SellerTestimonial[] = [
    {
        id: 1,
        name: "Ananya Rao",
        business: "Fashion Seller",
        title:
            "Growing my business with Salar",
        review:
            "The seller tools are simple to manage and help me understand orders clearly. Reaching new customers has become much easier.",
        image:
            "/assets/images/testimonials/test-6.jpg",
        rating: 5,
    },
    {
        id: 2,
        name: "Sara Khan",
        business:
            "Beauty & Personal Care Seller",
        title:
            "A platform built for sellers",
        review:
            "Listing products, tracking orders and managing inventory feels organised. I can focus more on my products and less on operations.",
        image:
            "/assets/images/testimonials/test-4.jpg",
        rating: 5,
    },
    {
        id: 3,
        name: "Nisha Verma",
        business:
            "Home & Lifestyle Seller",
        title:
            "Better visibility, better sales",
        review:
            "Salar has helped our collection reach customers beyond our usual market. The overall seller experience feels modern and straightforward.",
        image:
            "/assets/images/testimonials/test-8.jpg",
        rating: 5,
    },
    {
        id: 4,
        name: "Meera Joseph",
        business: "Electronics Seller",
        title:
            "Reliable support for my store",
        review:
            "Order management is clear and efficient, and the platform gives our products a professional presence in front of customers.",
        image:
            "/assets/images/testimonials/test-2.jpg",
        rating: 5,
    },
];

const SellerTestimonials = () => {
    return (
        <section className="seller-testimonials">
            <div className="seller-testimonials-container">
                <div className="seller-testimonials-header">
                    <span className="seller-testimonials-eyebrow">
                        SELLER STORIES
                    </span>

                    <h2>
                        Seller Testimonials
                    </h2>

                    <p>
                        Hear from sellers growing
                        their business and reaching
                        more customers with Salar.
                    </p>
                </div>

                <div className="seller-testimonials-grid">
                    {testimonials.map(
                        (item) => (
                            <article
                                className="seller-testimonial-card"
                                key={item.id}
                            >
                                <div className="seller-testimonial-image">
                                    <img
                                        src={
                                            item.image
                                        }
                                        alt={
                                            item.name
                                        }
                                    />

                                    <div className="seller-testimonial-seller-badge">
                                        <BadgeCheck
                                            size={
                                                13
                                            }
                                            strokeWidth={
                                                2
                                            }
                                        />
                                        Verified
                                        Seller
                                    </div>

                                    <span className="seller-testimonial-quote">
                                        <Quote
                                            size={
                                                16
                                            }
                                            strokeWidth={
                                                1.8
                                            }
                                        />
                                    </span>
                                </div>

                                <div className="seller-testimonial-content">
                                    <div className="seller-testimonial-rating">
                                        {[
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                        ].map(
                                            (
                                                star
                                            ) => (
                                                <Star
                                                    key={
                                                        star
                                                    }
                                                    size={
                                                        13
                                                    }
                                                    strokeWidth={
                                                        1.7
                                                    }
                                                    fill={
                                                        star <=
                                                            item.rating
                                                            ? "currentColor"
                                                            : "none"
                                                    }
                                                />
                                            )
                                        )}

                                        <span>
                                            {
                                                item.rating
                                            }
                                            .0
                                        </span>
                                    </div>

                                    <h3>
                                        {
                                            item.title
                                        }
                                    </h3>

                                    <p>
                                        {
                                            item.review
                                        }
                                    </p>

                                    <div className="seller-testimonial-author">
                                        <strong>
                                            {
                                                item.name
                                            }
                                        </strong>

                                        <span>
                                            {
                                                item.business
                                            }
                                        </span>
                                    </div>
                                </div>
                            </article>
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default SellerTestimonials;
